import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { LoadinganimationComponent } from '../loadinganimation/loadinganimation.component';
import { MenuNode } from '../../../../classes';


@Component({
    selector: 'app-setvalue',
    templateUrl: './setvalue.component.html',
    styleUrls: ['./setvalue.component.scss'],
    standalone: false
})
export class SetvalueComponent implements OnInit {
  eventSubscription:any;
  menuElements :Array<MenuNode>;
  currentElement:MenuNode;
  title:string;
  subtitle:string;
  submenuOpenOn:MenuNode;
  template_parameters:Array<string>;
  @Input('debug') debug:boolean = false;
  debugOut(msg:string){
    console.log("MenuComponent: "+msg);
  }

  constructor(private menuService: MenuService, private ioService: DataIoService ) { 

  }
getValue(){
  return this.menuService.getCurrentNode().getValue();
}


  eventHandler(event){
    switch(event){
      case 'pandown':
      case 'down':{
        this.menuService.currentNode.value--;
        break;
      }
      case 'panup':
      case 'up':{
        this.menuService.currentNode.value++;
        break;
      }
      case 'confirm':{
        this.debugOut("got confirm in menu.component.");
        if(this.menuService.hasNextMenuItem()){
          this.menuService.selectNextMenuItem();
        }
        break;
      }
      case 'back':{
       this.debugOut("got confirm in menu.component.");
        if(this.menuService.hasPreviousMenuItem()){
          this.menuService.selectPreviousMenuItem();
        }
        break; 
      }
    }
    
  }

  applyOpacity(){

  }
  ngOnInit() {
    this.debugOut("ngOnInit");
    this.title = this.menuService.currentNode.getTitle();
    this.subtitle = this.menuService.currentNode.getSubTitle();
    this.menuElements = this.menuService.currentNode.getChilds();
    this.currentElement = this.menuService.currentNode.getChildByIndex(0);
    this.eventSubscription = this.ioService.inputs.events$.subscribe(
      (event)=>{this.eventHandler(event);}
      );

  }
  ngOnDestroy(){
    this.debugOut("onDestroy");
    this.eventSubscription.unsubscribe();
  }

}